<template>
  <v-scale-transition>
    <kits-panel :kits-items="subscriberGroup">
      <h3 class="headline grey--text text-xs-center hidden-sm-and-down">
        Jom Bantu
      </h3>
    </kits-panel>
  </v-scale-transition>
</template>

<script>
export default {
  components: {
    KitsPanel: () => import(/* webpackChunkName: "kitsPanel" */ '@/components/KitsPanel'),
  },
  data () {
    return {
    }
  },
  computed: {
    subscriberGroup: function () {
      const menu = [
        {
          icon: 'mdi-sim-outline',
          path: '/jombantu_upload_simcard',
          title: 'Upload Simpack',
          desc: 'SIM for student registration',
        },
        {
          icon: 'mdi-format-list-numbered',
          path: '/jombantu_list',
          title: 'Student Listing',
          desc: 'Student list from school',
        },
        {
          icon: 'mdi-download',
          path: '/jombantu_doc',
          title: 'Document',
          desc: 'Document to download',
        },
        {
          icon: 'mdi-file-certificate',
          path: '/jombantu_cert',
          title: 'Certificate',
          desc: 'View and download certificate',
        },
      ]

      return menu
    },
  },
}
</script>
